import React from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import ErrorPage from './util/ErrorPage';
import ClientMaintainance from './Pages/ClientMaintainance';

const Routes1 = ({props}) => {
  const {path} = useRouteMatch();
  return (
    <React.Fragment>
      <Switch>
        <Route exact path={path}>
          <ClientMaintainance />
        </Route>
        <Route path={`${path}`} component={ClientMaintainance} />
        <Route path="*" component={ErrorPage} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes1;
